export const SET_IS_EMBEDDED = "SET_IS_EMBEDDED";